/**
 * Tiny shared flag: "an upload button is armed for paste right now". Kept in its own file so the app-wide paste
 * sheet (SharedFilesService) can read it without importing the button component (which would create an import loop
 * once the button uses the native-share service).
 */
let armed = false;

export function setPasteTargetArmed(value: boolean): void {
  armed = value;
}

export function isPasteTargetArmed(): boolean {
  return armed;
}
